import { Box, Button, Center, Flex, HStack, VStack } from '@chakra-ui/react'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { REPOSITORY } from '../../api/repository/Repository'
import FileDownloader from '../../components/FileDownloader/FileDownloader'
import FileUploader from '../../components/FileUploader/FileUploader'
import FormButtons from '../../components/FormButtons/FormButtons'
import UnderlineHeading from '../../components/UnderlineText/UnderlineHeading'
import Warning from '../../components/Warning/Warning'
import { useLoadingContext } from '../../utils/hooks/Context/LoadingContext'
import { useRequestStatusContext } from '../../utils/hooks/Context/RequestStatusContext'
import { useLabels } from '../../utils/hooks/useLabels/useLabels'
import { faArrowDown } from '@fortawesome/free-solid-svg-icons'
import { DataLoadError } from '../../components/DataLoadError/DataLoadError'

const formatCostCenter = (array) => {
  const { sEmpresa } = REPOSITORY.local.company.getCompanyData()
  return array.map((element) => ({
    sEmpresa,
    NombreCetroCosto: element['Nombre Centro Costo (Obligatorio)'],
  }))
}

const dataLoadErrorColumns = [
  {
    Header: 'Cetro Costo',
    accessor: 'NombreCetroCosto',
  },
  {
    Header: 'Mensaje',
    accessor: 'sObservacion',
  },
]

export default function MassiveCostCenter() {
  const { texts } = useLabels()
  const navigate = useNavigate()
  const [massiveData, setMassiveData] = useState([])
  const { handleOpen: handleOpenLoading, handleClose: handleCLoseLoading } =
    useLoadingContext()
  const { handleOpen, handleSetTitle, handleChangeBody, handleClose } =
    useRequestStatusContext()

  const [showDataLoadError, setShowDataLoadError] = useState(false)
  const [dataLoadError, setDataLoadError] = useState()
  const [validated, setValidated] = useState(false)

  const handleFile = (document) => {
    setValidated(false)
    if (document) {
      const formatedData = formatCostCenter(document)
      setMassiveData(formatedData)
    } else {
      setMassiveData([])
    }
  }

  const onGoBack = () => {
    navigate(-1)
  }
  const onStatusOK = (res) => {
    handleCLoseLoading()
    handleSetTitle(res.data.sMensaje, res.status)
    handleChangeBody(
      <Button
        variant="primary"
        onClick={() => {
          handleClose()
        }}
      >
        {'Continuar'}
      </Button>,
    )
    handleOpen()
  }

  const onStatusError = () => {
    handleOpenLoading()
    handleCLoseLoading()
    handleSetTitle('Centro de Costo ya existe', 400)
    handleChangeBody(
      <Button
        variant="primary"
        onClick={() => {
          handleClose()
        }}
      >
        Contactar a soporte ahora
      </Button>,
    )
    handleOpen()
  }

  const onSave = () => {
    handleOpenLoading()
    REPOSITORY.wsEmpresa.company
      .createMassiveCostCenter(massiveData)
      .then((res) => {
        if (res?.data?.sMensaje?.includes('Centro de Costos creados: 0')) {
          onStatusError()
        } else {
          onStatusOK(res)
        }
      })
      .catch(() => {
        onStatusError()
      })
      .finally(() => handleCLoseLoading())
  }

  const validateData = () => {
    if (massiveData?.length <= 0) return

    handleOpenLoading()
    REPOSITORY.wsEmpresa.company
      .validateCreateMassiveCostCenter(massiveData)
      .then((res) => {
        if (
          Array.isArray(res.data.lCentroCosto) &&
          res.data.lCentroCosto.length > 0
        ) {
          setDataLoadError(res.data.lCentroCosto)
          setShowDataLoadError(true)
        } else {
          setDataLoadError([])
          setShowDataLoadError(false)
          setValidated(true)
        }
      })
      .catch(() => {
        onStatusError()
      })
      .finally(() => handleCLoseLoading())
  }

  return (
    <VStack
      alignItems="flex-start"
      mb="40px"
      h="75vh"
      justifyContent="space-between"
    >
      <VStack alignItems="flex-start" spacing="80px">
        <UnderlineHeading
          text={'Carga masiva para Centros de Costo'}
          variant="h5"
        />
        <VStack alignItems="flex-start" spacing="45px">
          <Warning warningText={texts.massive_branch_office_warning} />

          <HStack spacing="82px" mt="45px" alignItems="flex-start">
            <FileDownloader
              linkToFile="/files/Amipass_CargaCentroCosto.xls"
              icon={faArrowDown}
            />
            <Flex direction="column">
              <UnderlineHeading
                variant="h5"
                text={texts.upload_excel_template}
              />
              <Box mt="43px">
                <FileUploader handleFile={handleFile} />
              </Box>
            </Flex>
            <Box>
              <Button
                mt="90px"
                variant="gray"
                disabled={validated}
                onClick={validateData}
              >
                Verificar información
              </Button>
            </Box>
          </HStack>
        </VStack>
      </VStack>
      <Center mb="20px" mt="10px" w="100%">
        <FormButtons
          isForm
          disabled={!validated}
          isValid={massiveData.length > 0 && validated}
          onBack={onGoBack}
          onContinue={onSave}
        />
      </Center>
      <DataLoadError
        data={dataLoadError}
        show={showDataLoadError}
        columns={dataLoadErrorColumns}
        onClose={() => {
          setShowDataLoadError(false)
        }}
      />
    </VStack>
  )
}
